import React from "react";
import { Award, CheckCircle } from "lucide-react";

interface MetierGuaranteesProps {
  profession: {
    title: string;
    description: string;
  };
}

const MetierGuarantees = ({ profession }: MetierGuaranteesProps) => {
  return (
    <section className="mb-16">
      <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
        <h1 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
          {profession.title}
        </h1>
        <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mb-8 rounded-full"></div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          <div className="lg:col-span-2">
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              {profession.description}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Le Groupe Fabre Environnement propose des solutions complètes de gestion des déchets spécialement conçues pour répondre aux besoins spécifiques de votre activité. Nos services incluent la collecte, le tri, le traitement et la valorisation de vos déchets professionnels dans le respect des normes environnementales.
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-fabre-lightgreen to-white p-6 rounded-2xl border border-fabre-green/20">
            <h2 className="text-xl font-heading font-bold mb-4 text-fabre-gray flex items-center">
              <Award className="h-6 w-6 text-fabre-green mr-3" />
              Nos garanties
            </h2>
            <ul className="space-y-3">
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-700">25 ans d'expérience</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-700">Conformité réglementaire</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-700">Taux de valorisation 85%</span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-gray-700">Traçabilité complète</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MetierGuarantees;